import * as de from './de';

export { de };
